import { ISelectableRowClasses } from "./ISelectableRowClasses";

export const getRowClassName = (index: number, length: number, classes: ISelectableRowClasses) => {
    const { selectableRowContainer, firstRow, lastRow, notFirstRow } = classes;

    if (index === 0) {
        return `${selectableRowContainer} ${firstRow}`;
    }
    if (index === length - 1) {
        return `${selectableRowContainer} ${lastRow} ${notFirstRow}`;
    }

    return `${selectableRowContainer} ${notFirstRow}`;
};
